'use strict';
    /**
     * Notification Functions : 11 JAN 2020
     * Chapter 247
     *
     *-------------------------------------------------------- */
    var notyDefaultOptions = {
        layout: 'topRight',
        theme: 'bootstrap-v4',
        progressBar: true,
        timeout: 3000,
        closeWith: ['click'],
        animation: {
            open: 'animated bounceInRight', // Animate.css class names
            close: 'animated bounceOutRight'
        } 
    };

    /*
    * Show Success Message
    *************************************************/
    function showSuccessMessage(message) {
        new Noty($.extend({}, notyDefaultOptions, {
            type: 'success',
            text: message
        })).show();
    }

    /*
    * Show Error Message
    *************************************************/
    function showErrorMessage(message) {
        new Noty($.extend({}, notyDefaultOptions, {
            type: 'error',
            text: message
        })).show();
    };

    /*
    * Show Info Message
    *************************************************/
    function showInfoMessage(message) {
        new Noty($.extend({}, notyDefaultOptions, {
            type: 'info',
            text: message
        })).show();
    };

    /*
    * Show Warning Message
    *************************************************/
    function showWarnMessage(message) {
        new Noty($.extend({}, notyDefaultOptions, {
            type: 'warning',
            text: message
        })).show();
    };

    /*
    * Show confirmation dialog
    *************************************************/
    function showConfirmation(containerId, yesCallback, options) {
        var $messageItem = $(containerId),
            confirmationContainer = '';

            if($messageItem.length) {
                confirmationContainer = $messageItem.html();
            } else {
                confirmationContainer = containerId;
            }
            if(!options) {
               options = {};
            }
        var confirmationDialog = new Noty($.extend({}, {
            layout: 'center',
            theme: 'bootstrap-v4',
            callbacks: {
                beforeShow:function() {
                    $('body').addClass('overflow-hidden');
                },
                onClose:function() {
                    $('body').removeClass('overflow-hidden');
                }
            },
            modal: true,
            closeWith:['button'],
            buttons: [
                Noty.button('YES', 'btn btn-success btn-sm mr-2', function () {
                    if(typeof yesCallback === 'function') {
                        yesCallback();
                        confirmationDialog.close();
                    }
                }),
                Noty.button('NO', 'btn btn-danger btn-sm', function () {
                    confirmationDialog.close();
                })
            ],
            text: confirmationContainer,
            animation: {
                open: 'animated fadeInDown faster', // Animate.css class names
                close: 'animated fadeOutUp faster'
            }
        }, options));
        confirmationDialog.show();
        return confirmationDialog;
    }